export default {
    en: {
        title: 'Store Profile',
        add: {
            title: 'Add Seller',
            fullName: 'First Name',
            phone: 'Phone Number',
            chooseUser: 'Choose user type',
            manager: 'Manager',
            seller: 'Seller',
            email: 'Email',
            password: 'Password',
            btn: 'Save Changes',
            success: "The seller's data has been saved successfully",
            alert: 'Sorry you already have 3 sellers in your account'
        },
        edit: {
            title: 'Edit Seller',
            fullName: 'First Name',
            phone: 'Phone Number',
            chooseUser: 'Choose user type',
            manager: 'Manager',
            seller: 'Seller',
            email: 'Email',
            password: 'Password',
            btn: 'Save Changes',
            alert: 'Sorry you already have 3 sellers in your account'
        },
        note: 'If you want to change your info',
        editBtn: 'Edit',
        sellers: {
            title: 'Sellers List',
            btn: 'Add Seller',
            tName: 'Name',
            tType: 'User Type',
            tPhone: 'Phone',
            tEmail: 'Email',
            tPassword: 'Password',
            actions: 'Actions'
        },
        messages: {
            editImg: 'The image has been saved successfully',
            editForm: 'The Information has been saved successfully'
        }

    },
    uz: {
        title: "Do'kon profili",
        add: {
            title: "Sotuvchi qo'shish",
            fullName: "To'liq ism",
            phone: "Telefon raqam",
            chooseUser: 'Foydalanuvchi turini tanlang',
            manager: 'Menejer',
            seller: 'Sotuvchi',
            email: 'Email',
            password: 'Parol',
            btn: 'Saqlash',
            alert: "Kechirasiz, hisobingizda 3ta sotuvchi bor"
        },
        edit: {
            title: "Sotuvchini tahrirlash",
            fullName: "To'liq ism",
            phone: "Telefon raqam",
            chooseUser: 'Foydalanuvchi turini tanlang',
            manager: 'Menejer',
            seller: 'Sotuvchi',
            email: 'Email',
            password: 'Parol',
            btn: 'Saqlash',
            success: "Sotuvchi ma'lumoti muvaffaqiyatli saqlandi",
            alert: "Kechirasiz, hisobingizda 3ta sotuvchi bor"
        },
        note: "Agar ma'lumotingizni o'zgartirishni xohlasangiz",
        editBtn: 'Tahrirlash',
        sellers: {
            title: "Sotuvchilar ro'yxati",
            btn: "Sotuvchi qo'shish",
            tName: "Ism",
            tType: "Foydalanuvchi turi",
            tPhone: "Telefon",
            tEmail: 'Email',
            tPassword: 'Parol',
            actions: 'Vazifalar'
        },
        messages: {
            editImg: "Rasm muvaffaqiyatli saqlandi",
            editForm: "Ma'lumot muvaffaqiyatli saqlandi"
        }

    },
    ru: {
        title: 'Профиль магазина',
        add: {
            title: 'Добавить продавца',
            fullName: 'ФИО',
            phone: 'Номер телефона',
            chooseUser: 'Выберите тип пользователя',
            manager: 'Менеджер',
            seller: 'Продавец',
            email: 'Email',
            password: 'Пароль',
            btn: 'Сохранить',
            success: 'Сохранить',
            alert: "Извините, у вас уже есть 3 продавца в вашем аккаунте"
        },
        edit: {
            title: 'Редактировать продавца',
            fullName: 'ФИО',
            phone: 'Номер телефона',
            chooseUser: 'Выберите тип пользователя',
            manager: 'Менеджер',
            seller: 'Продавец',
            email: 'Email',
            password: 'Пароль',
            btn: 'Сохранить',
            success: 'Данные продавца были успешно сохранены',
            alert: "Извините, у вас уже есть 3 продавца в вашем аккаунте"
        },
        note: 'Если вы хотите изменить свою информацию',
        editBtn: 'Редактировать',
        sellers: {
            title: 'Список продавцов',
            btn: 'Добавить продавца',
            tName: 'ФИО',
            tPhone: 'Телефон',
            tType: 'Тип пользователя',
            tEmail: 'Email',
            tPassword: 'Пароль',
            actions: 'Задачи'
        },
        messages: {
            editImg: 'Изображение было успешно сохранено',
            editForm: 'Информация была успешно сохранена'
        }

    }
}